export const SORT_KEY = "sort";
export const PAGE_KEY = "page";
export const FILTER_KEY = "filter";
export const PER_PAGE_KEY = "per_page";
